import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';

import * as serviceWorker from './serviceWorker';

import { Router, Route } from 'react-router-dom';
import history from './utils/history';
import './assets/base.scss';
import configureStore from './config/configureStore';
import 'react-datepicker/dist/react-datepicker.css';
import { Provider } from 'react-redux';
import Main from './layout/Main';
import rootSaga from './sagas';
import './styles.css';
import i18n from './i18n';

const store = configureStore();
const rootElement = document.getElementById('root');

store.runSaga(rootSaga);

const renderApp = (Component) => {
  ReactDOM.render(
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <Router history={history}>
          <Route component={Component} />
        </Router>
      </Provider>
    </I18nextProvider>,
    rootElement
  );
};

renderApp(Main);

if (module.hot) {
  module.hot.accept('./layout/Main', () => {
    const NextApp = require('./layout/Main').default;
    renderApp(NextApp);
  });
}
serviceWorker.unregister();
